import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SEGMENTS_QUERY_KEY} from "../queryKeys";

type Variables = {id: string};

const getSegmentTemplates = async (variables: Variables): Promise<string[]> => {
  const response = await axiosReachInstance.get<string[], AxiosResponse<string[]>>(
    `/segments/${variables.id}/templates`
  );
  return response.data;
};

export const useGetSegmentTemplates = (
  variables: Variables,
  options?: BaseQueryOptions<string[], Variables>
): BaseUseQueryResult<string[]> => {
  return useBaseQuery<string[], Variables>(
    [SEGMENTS_QUERY_KEY, variables.id, "templates"],
    getSegmentTemplates,
    variables,
    options
  );
};
